/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PregnancyPrescription from './pregnancy-prescription';
import PregnancyPrescriptionDetail from './pregnancy-prescription-detail';
import PregnancyPrescriptionUpdate from './pregnancy-prescription-update';
import PregnancyPrescriptionDeleteDialog from './pregnancy-prescription-delete-dialog';

const PregnancyPrescriptionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PregnancyPrescription />} />
    <Route path="new" element={<PregnancyPrescriptionUpdate />} />
    <Route path=":id">
      <Route index element={<PregnancyPrescriptionDetail />} />
      <Route path="edit" element={<PregnancyPrescriptionUpdate />} />
      <Route path="delete" element={<PregnancyPrescriptionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PregnancyPrescriptionRoutes;
